import React, { useEffect, Component, useState, useRef } from 'react';
import Header from '../../containers/Header';
import Footer from '../../containers/Footer';
import { Link, useHistory, useParams } from 'react-router-dom';
import { ApiService } from '../../containers/Services/apiservice';
import * as moment from 'moment';
import { Watch } from "react-loader-spinner";
let apiServices = new ApiService();
const MfSipDetail = () => {
  let history = useHistory();
  const didMountRef = useRef(true);
  const { id } = useParams();
  const { goalid } = useParams();
  const [mutualfund, setmutualfund] = useState({});
  const [spinnerLoading, setSpinnerLoading] = useState(false);
  const [CANid, setCANid] = useState('');
  const [Bankno, setBankno] = useState();
  const [UserBankData, SetUserBankData] = useState({});
  const [InputData, setInputData] = useState([{ amount: '', sipdate: '', sipfrequency: '', bankno: '' }]);
  const [ReqError, setReqError] = useState(0);
  const [SipYears, SetSipYears] = useState(10);
  const [ReqErrorMsg, setReqErrorMsg] = useState('');
  const [otpprocess, setotpprocess] = useState(0);
  const [otp, Setotp] = useState('');
  const [countermob, setCountermob] = React.useState(0);
  const [errorMessage, setErrorMessage] = useState('');
  // const [MFArray, setMFArray] = useState([]);
  useEffect(() => {
    if (didMountRef.current) {
      // setMFArray(JSON.parse(localStorage.getItem("SELMFS")));
      setSpinnerLoading(true);
      const dataStringuser = {
      }
      apiServices.getUserData(dataStringuser).then(result => {
        if (result.data.status == 'success') {
          setCANid(result.data.data.gs_can_id);
        }
        else if (result.data.status == "error" && result.data.message == "Session expired") {
          localStorage.removeItem('AUTH_TOKEN');
          // alert(result.data.message)
          setSpinnerLoading(false)
          history.push("/login")
        }
        else {
          alert(result.data.message)
          setSpinnerLoading(false)
          return false
        }
      })
      const dataString = {
        "id": JSON.parse(localStorage.getItem("SELMFS")),
      }
      apiServices.getselectedmutualfunds(dataString).then(res => {
        if (res.data.status == 'success') {
          setmutualfund(res.data.data);
          setSpinnerLoading(false);
        }
        else if (res.data.status == "error" && res.data.message == "Session expired") {
          localStorage.removeItem('AUTH_TOKEN');
          // alert(res.data.message)
          setSpinnerLoading(false)
          history.push("/login")
        }
        else {
          alert(res.data.message)
          setSpinnerLoading(false)
          return false
        }
      })
      getusrbanks();
    }
    didMountRef.current = false;
  });
  React.useEffect(() => {
    countermob > 0 && setTimeout(() => setCountermob(countermob - 1), 1000);
  }, [countermob]);
  const arr = [];
  const handleInput = (id, event) => {
    var future = new Date();
    var currentmonth = moment(future).format('MM');
    const index = mutualfund.findIndex((data) => data.mf_id === id)
    let _inviteMembers = [...mutualfund];
    _inviteMembers[index][event.target.name] = event.target.value
    setmutualfund(_inviteMembers)
    return false;
  }
  const getusrbanks = () => {
    const dataString = {
    }
    apiServices.getusercanbankdata(dataString).then(res => {
      if (res.data.status == 'success') {
        SetUserBankData(res.data.data)
      }
      else if (res.data.status == "error" && res.data.message == "Session expired") {
        localStorage.removeItem('AUTH_TOKEN');
        // alert(res.data.message)
        setSpinnerLoading(false)
        history.push("/login")
      }
      else {
        alert(res.data.message)
        setSpinnerLoading(false)
        return false
      }
    }
    )
  }
  const openInNewTab = (url) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }
  function getdate() {
    var future = new Date();
    // future.setDate(future.getDate() + 15);
    // var currentDate = moment('2015-10-30');
    var futureMonth = moment(future).add(1, 'M');
    return moment(futureMonth).format('YYYY-MM');
    //var date = future.getFullYear() + '-' + (future.getMonth() + 1) + '-' + ('0'+future.getDate()).slice(-2);
    // return date;
  }
  const sendotp = () => {
    for (var i = 0; i < mutualfund.length; i++) {
      if (mutualfund[i].sipfrequency == '' || mutualfund[i].sipfrequency == null) {
        setReqError(1);
        setReqErrorMsg('All Frequency Of Sip Fields Are Required.');
        return false;
      }
      else if (mutualfund[i].sipdate == '' || mutualfund[i].sipdate == null) {
        mutualfund[i].sipdate = getdate();
        // setReqError(1);
        // setReqErrorMsg('All Date To Deduct Sip Amount Fields Are Required.');
        // return false;
      }
      else if (mutualfund[i].amount == '' || mutualfund[i].amount == null) {
        setReqError(1);
        setReqErrorMsg('All Amount Fields Are Required.');
        return false;
      }
      else {
        setReqError(0);
      }
    }
    const dataString = {
    }
    setSpinnerLoading(true);
    apiServices.sendtxnotp(dataString).then(result => {
      if (result.data.status == 'success') {
        setSpinnerLoading(false);
        setCountermob(30);
        setotpprocess(1);
      }
      else {
        setSpinnerLoading(false);
        setErrorMessage(result.data.message);
      }
    })
  }
  const verifyotp = () => {
    const dataString = {
      "mobile_otp": otp
    }
    setSpinnerLoading(true);
    apiServices.verifytxnotp(dataString).then(result => {
      if (result.data.status == 'success') {
        siptransaction();
        setSpinnerLoading(false);
      }
      else {
        setErrorMessage(result.data.message);
        setSpinnerLoading(false);
      }
    })
  }
  const siptransaction = () => {
    for (var i = 0; i < mutualfund.length; i++) {
      if (mutualfund[i].sipfrequency == '' || mutualfund[i].sipfrequency == null) {
        setReqError(1);
        setReqErrorMsg('All Frequency Of Sip Fields Are Required.');
        return false;
      }
      else if (mutualfund[i].sipdate == '' || mutualfund[i].sipdate == null) {
        mutualfund[i].sipdate = getdate();
        // setReqError(1);
        // setReqErrorMsg('All Date To Deduct Sip Amount Fields Are Required.');
        // return false;
      }
      else if (mutualfund[i].amount == '' || mutualfund[i].amount == null) {
        setReqError(1);
        setReqErrorMsg('All Amount Fields Are Required.');
        return false;
      }
      else {
        setReqError(0);
      }
    }
    const dataString = {
      "mfdata": mutualfund,
      "bankno": Bankno,
      "goalid": goalid,
      "sipyears": SipYears,
      "type": 'SIP'
    }
    setSpinnerLoading(true);
    apiServices.siptransaction(dataString).then(result => {
      if (result.data.status == 'success') {
        setTimeout(() => {
          history.push("/dashboard");
        }, 3000);
        setSpinnerLoading(false);
        openInNewTab(result.data.redirectURL)
      }
      else if (result.data.status == "error" && result.data.message == "Session expired") {
        localStorage.removeItem('AUTH_TOKEN');
        // alert(result.data.message)
        setSpinnerLoading(false)
        history.push("/login")
      }
      else {
        alert(result.data.message);
        setSpinnerLoading(false);
      }
      // if(res.data.status=='success'){
      //   setSpinnerLoading(false);
      //   siptransaction(false);
      //   if(res.data.message === 'txn_success')
      //   {
      //     history.push('/thankyou/'+btoa(res.data.txnid))
      //   } else{ 
      //     setSpinnerLoading(false);
      //     siptransaction(false); 
      //   alert('Some Error Occured Please Try Again');
      //   Window.location.reload();
      //   }
      // }
      // else{
      //   setSpinnerLoading(false);
      //   siptransaction(false);
      //   alert(res.data.message);
      //   return false;
      // }
      // console.log("aaaaa",res.data.PurchaseAndSIPTxnForm);
    })
  }
  return (
    <div>
      <div className={spinnerLoading == true ? 'parentDisable' : ''} width="100%">
        <div className='overlay-box'>
          <Watch
            color="#ffffff"
            visible={spinnerLoading}
          />
        </div>
      </div>
      <Header />
      {otpprocess == 0 ?
        <section className='bg-gray-light section-small'>
          <div className="container">
            <div className='row justify-content-md-center'>
              <div className='col-lg-8'>
                {mutualfund.length > 0
                  ? mutualfund.map((key) => (
                    <div className='mfsipbox mg-b-15'>
                      <div className='mfsipbox-planname'>{key.plan_name}</div>
                      <div className='mfshipboxform'>
                        <div className='row'>
                          <div className='col-lg-12'>
                            <div className='mfshipboxform-group'>
                              <label>Frequency Of Sip<span style={{ color: '#ff0000' }}>*</span></label>
                              <select name="sipfrequency" onChange={(e) => handleInput(key.mf_id, e)}>
                                <option value="">Select</option>
                                {key.selfrequency.length > 0
                                  ? key.selfrequency.map((freqvalue) => (
                                    <>
                                      <option value={freqvalue.frequency_code}>{freqvalue.frequency_name}</option>
                                    </>
                                  )) : ""}
                              </select>
                            </div>
                          </div>
                          {goalid == 0 ?
                            <div className='col-lg-12'>
                              <div className='mfshipboxform-group'>
                                <label>For How Many Years You Want To Invest Years<span style={{ color: '#ff0000' }}>*</span></label>
                                <input name="sipyears" value={SipYears} onChange={(e) => SetSipYears(e.target.value)} type="number"></input>
                              </div>
                            </div> : ''
                          }
                          <div className='col-lg-6'>
                            <div className='mfshipboxform-group'>
                              <label>Select Date To Deduct Sip Amount<span style={{ color: '#ff0000' }}>*</span></label>
                              <select name="sipday" onChange={(e) => handleInput(key.mf_id, e)}>
                                <option value="">Select Date</option>
                                {key.seldates.length > 0
                                  ? key.seldates.map((value) => (
                                    <>
                                      <option value={value}>{value}</option>
                                    </>
                                  )) : ""}
                              </select>
                              <span className='inpfeed'>Select Date After 15 Days From Current Date</span>
                            </div>
                          </div>
                          <div className='col-lg-6'>
                            <div className='mfshipboxform-group'>
                              <label>Select Starting Month of The Sip<span style={{ color: '#ff0000' }}>*</span></label>
                              <input name="sipdate" min={getdate()} value={getdate()} onChange={(e) => handleInput(key.mf_id, e)} type="month" disabled=""></input>
                            </div>
                          </div>
                          <div className='col-lg-12'>
                            <div className='mfshipboxform-group'>
                              <label>Amount<span style={{ color: '#ff0000' }}>*</span></label>
                              <input name="amount" onChange={(e) => handleInput(key.mf_id, e)} type="number"></input>
                              <span className='inpfeed'>Min SIP Amount : {key.minamount}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                  : ""}
                <div className='mfsipbox mg-b-15'>
                  <div className='mfsipbox-planname'>Select Bank Details</div>
                  <div className='mfshipboxform'>
                    <div className='row'>
                      <div className='col-lg-12'>
                        <div className='mfshipboxform-group'>
                          <select name="bankno" value={Bankno} onChange={(e) => setBankno(e.target.value)}>
                            {UserBankData.crb_bank_acc_no1 != null ?
                              <option value="1">{UserBankData.crb_bank1} -- {UserBankData.crb_bank_acc_no1.replace(/.(?=.{4})/g, 'X')} -- (Primary)</option> : ''
                            }
                            {UserBankData.crb_bank_acc_no2 != null ?
                              <option value="2">{UserBankData.crb_bank2} -- {UserBankData.crb_bank_acc_no2.replace(/.(?=.{4})/g, 'X')}</option> : ''
                            }
                            {UserBankData.crb_bank_acc_no3 != null ?
                              <option value="3">{UserBankData.crb_bank3} -- {UserBankData.crb_bank_acc_no3.replace(/.(?=.{4})/g, 'X')}</option> : ''
                            }
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {ReqError == 1 ?
                  <p style={{ color: '#FF0000', textAlign: 'center' }}>{ReqErrorMsg}</p>
                  : ''
                }
                <div class="theme-button mg-t-20"><a class="btn button02" onClick={() => siptransaction()}>Proceed</a></div>
              </div>
            </div>
          </div>
        </section>
        : <section className='bg-gray-light section-small'>
          <div className="container">
            <div className='row justify-content-md-center'>
              <div className='col-lg-8'>
                <div className='mfsipbox mg-b-15'>
                  <div className='mfsipbox-planname'>Verify OTP</div>
                  <div className='mfshipboxform'>
                    <div className='row'>
                      <div className='col-lg-12'>
                        <div className='mfshipboxform-group'>
                          <label>Enter OTP<span style={{ color: '#ff0000' }}>*</span></label>
                          <input name="otp" onChange={(e) => Setotp(e.target.value)} type="number"></input>
                          {
                            countermob == 0 ?
                              <p className="tx-12 mg-t-5"  >Didn't receive OTP? Resend <Link onClick={sendotp}>(Click Here)</Link></p> :
                              <p className="tx-12 mg-t-5"  >Resend OTP in {countermob} seconds</p>
                          }
                        </div>
                        {
                          errorMessage != '' ? <p className="text text-danger">{errorMessage}</p> : null
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div class="theme-button mg-t-20"><a class="btn button02" onClick={verifyotp}>Submit</a></div>
              </div>
            </div>
          </div>
        </section>}
      <Footer />
    </div>
  );
}
export default MfSipDetail;